import React from "react";
import Grid from "@mui/material/Grid";


const GridItemOffset = ({ xs, md }) => {
    return <Grid item xs={xs} md={md} display={{ xs: 'none', md: 'block' }}/>
}

export default React.memo(GridItemOffset, (prevProps, nextProps) => {
    return prevProps.xs === nextProps.xs && prevProps.md === nextProps.md;
})